import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { TopBarComponent } from './top-bar.component';
import { LicenseDialogComponent } from './license-Dialog/license-dialog.component'
@NgModule({
    imports: [SharedModule],
    declarations: [TopBarComponent,LicenseDialogComponent],
    entryComponents: [TopBarComponent],
    exports: [TopBarComponent]
})
export class TopBarModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/top-bar/top-bar.module.ts